// extracted by mini-css-extract-plugin
export default {"tag-mark":"TagMark_tag-mark__cPupg","success":"TagMark_success__abTB0"};